
    import { defineComponent } from "vue";
    import { useI18n } from "vue-i18n";

    export default defineComponent({
        name: "error-500",
        components: {},
        setup() {
            const { t } = useI18n(); 
            return {   t };
        }
    });
